import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import i18n from "i18n"

import MetricCard from "./MetricCard"
import LineChartCard from "./LineChartCard"
import EvolutionGapsPanel from "./EvolutionGapsPanel"
import {
  OVERVIEW_CARDS_GRID_GAP,
  overviewCardsGridSx3,
} from "./constants/overviewGrid"

const CertificationsSection = ({ data, isLoading }) => {
  const cards = (data?.cards ?? []).map(card => (
    <Box key={card.id ?? card.title} sx={{ minWidth: 0 }}>
      <MetricCard {...card} loading={isLoading} />
    </Box>
  ))

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: OVERVIEW_CARDS_GRID_GAP,
      }}
    >
      <Box sx={overviewCardsGridSx3}>{cards}</Box>
      <Box
        sx={{
          display: "grid",
          gap: OVERVIEW_CARDS_GRID_GAP,
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            lg: "minmax(0, 2fr) minmax(0, 1fr)",
          },
          alignItems: "stretch",
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <LineChartCard
            title={i18n.t("overview.evolutionAccumulatedChartTitle")}
            xData={data?.lineChart?.dates ?? []}
            seriesData={data?.lineChart?.series ?? []}
            isLoading={isLoading}
            currency={data?.currency}
          />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <EvolutionGapsPanel
            gaps={data?.gaps}
            isLoading={isLoading}
            currency={data?.currency}
          />
        </Box>
      </Box>
    </Box>
  )
}

CertificationsSection.propTypes = {
  data: PropTypes.shape({
    currency: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.object),
    gaps: PropTypes.shape({
      certifiedInvoicedGap: PropTypes.number,
      totalCertified: PropTypes.number,
      totalInvoiced: PropTypes.number,
      invoicedCollectedGap: PropTypes.number,
      totalInvoiceAmount: PropTypes.number,
      totalPaidAmount: PropTypes.number,
      unpaidInvoiceCount: PropTypes.number,
    }),
    lineChart: PropTypes.shape({
      dates: PropTypes.arrayOf(PropTypes.string),
      series: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
  isLoading: PropTypes.bool.isRequired,
}

export default CertificationsSection
